import type { SVGProps } from 'react';
const SvgTrash = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_941_15683)">
      <path
        d="M1.75 3.5H2.91667H12.25"
        stroke="#757575"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.0834 3.49935V11.666C11.0834 11.9754 10.9605 12.2722 10.7417 12.491C10.5229 12.7098 10.2262 12.8327 9.91675 12.8327H4.08341C3.774 12.8327 3.47725 12.7098 3.25846 12.491C3.03966 12.2722 2.91675 11.9754 2.91675 11.666V3.49935M4.66675 3.49935V2.33268C4.66675 2.02326 4.78966 1.72652 5.00846 1.50772C5.22725 1.28893 5.524 1.16602 5.83341 1.16602H8.16675C8.47617 1.16602 8.77291 1.28893 8.99171 1.50772C9.2105 1.72652 9.33342 2.02326 9.33342 2.33268V3.49935"
        stroke="#757575"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.83325 6.41602V9.91602"
        stroke="#757575"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.16675 6.41602V9.91602"
        stroke="#757575"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_941_15683">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgTrash;
